import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { NivelControlCredito, UsuarioNivelControlCredito } from '@shared/models/controlCredito/NivelControlCredito';
import { ControlCreditoService } from '@controlCredito/control-credito.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { MessageService } from '@shell/message.service';

@Component({
  selector: 'app-niveles-detalle',
  standalone: true,
  imports: [NgbAlert, CommonModule],
  templateUrl: './niveles-detalle.component.html',
  styleUrl: './niveles-detalle.component.scss'
})
export class NivelesDetalleComponent implements OnInit, OnChanges {

  usuariosNivel: UsuarioNivelControlCredito[] = [];
  eliminandoUsuario: number = null;

  @Input() nivelSeleccionado: NivelControlCredito;
  @Output() updateUsuarios = new EventEmitter<UsuarioNivelControlCredito[]>();

  constructor(
    private controlCreditoService: ControlCreditoService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.actualizarLista();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['nivelSeleccionado']) {
      this.actualizarLista();
    }
  }

  private actualizarLista() {
    if (!this.nivelSeleccionado) {
      this.usuariosNivel = [];
    } else {
      this.usuariosNivel = [
        ...(this.nivelSeleccionado.usuarios ?? []),
        ...(this.nivelSeleccionado.delegaciones ?? [])
      ];
      console.log(this.usuariosNivel)
    }
  }

  borrarUsuario(i) {
    this.eliminandoUsuario = i;
    const dto = new UsuarioNivelControlCredito();
    dto.nivelId = this.nivelSeleccionado.id
    dto.usuario = this.usuariosNivel[i].usuario;

    if (this.usuariosNivel[i].fechaHasta) {
      this.controlCreditoService.eliminarDelegacion(dto).subscribe(
        () => {
          this.usuariosNivel.splice(i, 1);
          this.updateUsuarios.emit(this.usuariosNivel);
          this.eliminandoUsuario = null;
          this.messageService.showSuccessMessage('Delegación eliminada exitosamente.');
        },
        (err: ErrorModel) => {
          this.messageService.showErrorMessage(err.message + '\n' + err.description);
          this.eliminandoUsuario = null;
        }
      );
    } else {
      this.controlCreditoService.eliminarUsuario(dto).subscribe(
        () => {
          this.usuariosNivel.splice(i, 1);
          this.updateUsuarios.emit(this.usuariosNivel);
          this.eliminandoUsuario = null;
          this.messageService.showSuccessMessage('Usuario eliminado exitosamente.');
        },
        (err: ErrorModel) => {
          this.messageService.showErrorMessage(err.message + '\n' + err.description);
          this.eliminandoUsuario = null;
        }
      );
    }
  }
}